import { useEffect, useState } from 'react';
import type { WidgetProps } from '@frontend/widgets/types';
import { fetchWidgetData } from '../api';

interface Build {
	number: number;
	status: string;
	branch: string;
	message: string;
	author: string;
	created: number | null;
	htmlUrl: string | null;
	repoName: string;
}

export default function WoodpeckerBuildStatusWidget({ contextType, contextId, ecosystemId }: WidgetProps) {
	const [builds, setBuilds] = useState<Build[]>([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');

	useEffect(() => {
		setLoading(true);
		setError('');
		const params: Record<string, string> = { ecosystemId, contextType, contextId };

		fetchWidgetData<{ builds: Build[] }>('woodpecker-build-status', params)
			.then((d) => setBuilds(d.builds || []))
			.catch((err: Error) => setError(err.message))
			.finally(() => setLoading(false));
	}, [contextType, contextId, ecosystemId]);

	if (loading) return <div className="widget-inner-loading">Loading builds…</div>;
	if (error) return <div className="widget-inner-error">{error}</div>;
	if (!builds.length) return <div className="widget-inner-empty">No recent builds found.</div>;

	return (
		<ul className="widget-list">
			{builds.map((b, i) => (
				<li key={i} className="widget-list-item">
					<div className="widget-list-primary">
						{b.htmlUrl
							? <a href={b.htmlUrl} target="_blank" rel="noopener noreferrer">{b.message || `Build #${b.number}`}</a>
							: <span>{b.message || `Build #${b.number}`}</span>
						}
					</div>
					<div className="widget-list-meta">
						<span className={`widget-build-badge widget-build-${b.status}`}>{b.status}</span>
						<span>{b.repoName}</span>
						<span>{b.branch}</span>
						{b.created && <span>{new Date(b.created * 1000).toLocaleDateString()}</span>}
					</div>
				</li>
			))}
		</ul>
	);
}
